<fieldset>
  <label [raskRequired]="required">
    {{label}}
    @if (infoText) {
      <rask-info>{{infoText}}</rask-info>
    }
  </label>
  <ng-select #instance
    [id]="aid"
    [addTag]="false"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [groupBy]="groupBy"
    [clearAllText]="clearAllTooltipText"
    [disabled]="disabled"
    [readonly]="readonly"
    [hideSelected]="hideSelected"
    [minTermLength]="minTermLength"
    [loading]="loading"
    [compareWith]="compareWith"
    [loadingText]="loadingText"
    [notFoundText]="notFoundText"
    [typeToSearchText]="typeToSearchText"
    [typeahead]="typeaheadInput$"
    [items]="items | async"
    [multiple]="false"
    [searchFn]="searchFn"
    [(ngModel)]="selected"
    [ngModelOptions]="{standalone: true}"
    (change)="onSelectionChange($event)">
    @if (headerOptions) {
      <ng-template ng-header-tmp>
        @for (headerOption of headerOptions; track headerOption) {
          <div class="header-option" (click)="headerOptionClick(headerOption)">
            <span class="rask-search">{{getLabel(headerOption.data)}}</span>
          </div>
        }
      </ng-template>
    }
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="rask-search">{{getLabel(item)}}</span>
        </div>
      }
    </ng-template>
  </ng-select>

  @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
  }
</fieldset>